import {DictWeapon} from "../../../../model/Dto/Dict/Weapon";
import {ApiRequest, RequestMethod} from "../../../request";

export async function getAllWeapons(weaponType?: number): Promise<DictWeapon[]> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.GET);
    let url = "/api/weapon";
    if (weaponType !== undefined && weaponType !== null) {
        url += `?WeaponType=${weaponType}`;
    }
    apiRequest.setUrl(url);
    const response: any = await apiRequest.send();
    return response.data;
}